import React, { Component } from "react";
//import Table from "react-bootstrap/Table";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Form from "react-bootstrap/Form";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import { Link } from "react-router-dom";
//import { KTSVG, toAbsoluteUrl } from '../../../../_metronic/helpers'*/
import { PageTitle } from "../../../../_metronic/layout/core";
import { KTSVG } from '../../../../_metronic/helpers'
import { Accordion, Card, FormGroup, FormLabel } from "react-bootstrap";
import { CSVLink } from "react-csv";
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';

const API_URL = process.env.REACT_APP_API_URL;
let auth;

let searchStringInit = {
    entrevistador: '',
    entidad: '',
    emi: '',
    clasificacion: '',
    nombre: '',
    tipoTestimoniante: '',
    tipoEntrevista: '',
    graveViolacion: '',
    subcontexto: '',
    grupoMilitancia: '',
    transcriptor: '',
    audioEntrevista: 0,
    transWhisper: 0
}

class EntrevistaIndividualIndex extends Component {

    constructor(props) {
        super(props);
        console.log(this.props)
        this.state = { data: [], searchFile: false, searchString: [], dataExcel: [] };
        this.refreshTable = this.refreshTable.bind(this);
        auth = JSON.parse(localStorage.getItem("kt-auth-react-v"));
        const { currentUser } = this.props;
        this.currentUser = currentUser;
    }

    async componentDidMount() {
        await this.refreshTable();
        try {
            const response = await fetch(`${API_URL}/GravesViolaciones/getAll`, {
                method: 'GET',
                headers: {
                    'auth-token': auth.api_token,
                }
            });
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const data = await response.json();
            this.setState({ violaciones: data });
        } catch (err) {
            console.log(err.message);
        };
    }

    async refreshTable() {
        try {
            const response = await fetch(`${API_URL}/entrevista/getAll`, {
                method: 'GET',
                headers: {
                    'auth-token': auth.api_token,
                }
            });
            if (!response.ok) {
                throw Error(response.statusText);
            }
            const data = await response.json();
            await this.setState({ data: data });
            await this.formatCsvData(data);
        } catch (err) {
            console.log(err.message);
        };
    }

    async formatCsvData(data) {
        var moment = require('moment')
        /* let dataCsv = [
            ["Clasificación", "Entidad", "Lugar", "Fecha", "Nombre", "Tipo Testimoniante", "Grupo de Militancia", "Pertenecía a Colectivo", "EMI responsable", "Entrevistador(E)/Asistente(A)",
                "Transcriptor", "Tipo de entrevista", "Duración", "Graves violaciones", "Subcontextos", "Sesiones", "Material adicional", "Tipo de material adicional"]
        ]; */
        let dataCsv = []
        data.map(item => {
            let grav = ""
            item.gravesViolaciones.map(ggg => {
                grav += `${ggg.nombre}, `
            })
            grav = grav.replace(/,\s*$/, "");
            let subC = ""
            item.subcontextos.map(sub => {
                subC += `${sub.nombre}, `
            })
            subC = subC.replace(/,\s*$/, "");
            const info = {
                "Clasificación": item.clasificacion, "Entidad": item.entidad, "Lugar": item.lugar, "Fecha": moment(item.fecha).format('YYYY-MM-DD'), "Nombre": item.persona[0].nombre, "Tipo Testimoniante": item.tipoTestimoniante, "Grupo de Militancia": item.grupoMilitancia,
                "Pertenecía a Colectivo": item.colectivo, "EMI responsable": item.emi, "Entrevistador(E)/Asistente(A)": item.entrevistador, "Transcriptor": item.transcriptor, "Tipo de entrevista": item.tipoEntrevista,
                "Duración": item.duracion, "Graves violaciones": grav, "Subcontextos": subC, "Sesiones": item.sesiones, "Material adicional": item.materialAdicional, "Tipo de material adicional": item.tipoMaterialAdicional
            };
            dataCsv.push(info);
        })
        console.log(dataCsv)
        await this.setState({ dataExcel: dataCsv })
    }

    async onChange(e) {
        if (e.target.id == 'archivos') {
            await this.setState({ searchFile: !this.state.searchFile })
        }
        const oldData = [...this.state.searchString];
        const newData = oldData.filter(item => item.key !== e.target.id);
        newData.push({ key: e.target.id, value: e.target.value });
        await this.setState({ searchString: newData });
        console.log(this.state.searchString)
        await this.onSearch()
    }

    async onSearch() {
        await this.setState({ data: [] })
        let formSerialized = searchStringInit;
        this.state.searchString.map(item => {
            Object.assign(formSerialized, { [item.key]: item.value });
            return item.value;
        });
        const busqueda = { buscar: formSerialized, archivos: this.state.searchFile }
        try {
            const response = await fetch(`${API_URL}/entrevista/search`, {
                method: 'POST',
                body: JSON.stringify(busqueda),
                headers: {
                    'Content-Type': 'application/json',
                    'auth-token': auth.api_token,
                }
            });
            const personas = await response.json();
            if (response.status >= 200 && response.status < 300) {
                await this.setState({ data: personas })
                await this.formatCsvData(personas);
            }
            else {
                console.log(personas);
            }
        } catch (err) {
            console.log("se murio");
        }
    }

    async exportCSV(csvData, fileName) {

        const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
        const fileExtension = '.xlsx';
        const ws = XLSX.utils.json_to_sheet(csvData);
        const wb = { Sheets: { 'data': ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
    }

    render() {
        var moment = require('moment');
        return (
            <>
                <PageTitle>Testimoniales</PageTitle>
                <Container fluid>
                    <Form>
                        <h1>Busqueda:</h1>
                        <Row>
                            <Col md={4}>
                                <Form.Group controlId="clasificacion">
                                    <FloatingLabel
                                        controlId="clasificacion"
                                        label="Clasificación"
                                        className="mb-3"
                                    >
                                        <Form.Control
                                            type="text"
                                            onChange={(e) => { this.onChange(e) }}
                                            placeholder="Buscar Entrevista" />
                                    </FloatingLabel>
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group controlId="nombre">
                                    <FloatingLabel
                                        controlId="nombre"
                                        label="Nombre testimoniante"
                                        className="mb-3"
                                    >
                                        <Form.Control
                                            type="text"
                                            onChange={(e) => { this.onChange(e) }}
                                            placeholder="Buscar Entrevista" />
                                    </FloatingLabel>
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group controlId="audioEntrevista">
                                    <Form.Select onChange={(e) => { this.onChange(e) }}>
                                        <option value={0}>Con/Sin Audio (Todos)</option>
                                        <option value={1}>Con Audio</option>
                                        <option value={2}>Sin Audio</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Accordion>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Más Filtros</Accordion.Header>
                                    <Accordion.Body>
                                        <Row>
                                            <Col md={4}>
                                                <Form.Group controlId="emi">
                                                    <FloatingLabel
                                                        controlId="emi"
                                                        label="EMI"
                                                        className="mb-3"
                                                    >
                                                        <Form.Control
                                                            type="text"
                                                            onChange={(e) => { this.onChange(e) }}
                                                            placeholder="Buscar Entrevista" />
                                                    </FloatingLabel>
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group controlId="entrevistador">
                                                    <FloatingLabel
                                                        controlId="entrevistador"
                                                        label="Nombre entrevistador"
                                                        className="mb-3"
                                                    >
                                                        <Form.Control
                                                            type="text"
                                                            onChange={(e) => { this.onChange(e) }}
                                                            placeholder="Buscar Entrevista" />
                                                    </FloatingLabel>
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group controlId="transcriptor">
                                                    <FloatingLabel
                                                        controlId="transcriptor"
                                                        label="Nombre transcriptor"
                                                        className="mb-3"
                                                    >
                                                        <Form.Control
                                                            type="text"
                                                            onChange={(e) => { this.onChange(e) }}
                                                            placeholder="Buscar Entrevista" />
                                                    </FloatingLabel>
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group controlId="tipoTestimoniante">
                                                    <FloatingLabel
                                                        controlId="tipoTestimoniante"
                                                        label="Tipo de Testimoniante"
                                                        className="mb-3"
                                                    >
                                                        <Form.Control
                                                            type="text"
                                                            onChange={(e) => { this.onChange(e) }}
                                                            placeholder="Buscar Entrevista" />
                                                    </FloatingLabel>
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group controlId="tipoEntrevista">
                                                    <FloatingLabel
                                                        controlId="tipoEntrevista"
                                                        label="Tipo de entrevista"
                                                        className="mb-3"
                                                    >
                                                        <Form.Control
                                                            type="text"
                                                            onChange={(e) => { this.onChange(e) }}
                                                            placeholder="Buscar Entrevista" />
                                                    </FloatingLabel>
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group controlId="graveViolacion">
                                                    <FloatingLabel
                                                        controlId="graveViolacion"
                                                        label="Grave violacion"
                                                        className="mb-3"
                                                    >
                                                        <Form.Control
                                                            type="text"
                                                            onChange={(e) => { this.onChange(e) }}
                                                            placeholder="Buscar Entrevista" />
                                                    </FloatingLabel>
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group controlId="subcontexto">
                                                    <FloatingLabel
                                                        controlId="subcontexto"
                                                        label="Subcontexto"
                                                        className="mb-3"
                                                    >
                                                        <Form.Control
                                                            type="text"
                                                            onChange={(e) => { this.onChange(e) }}
                                                            placeholder="Buscar Entrevista" />
                                                    </FloatingLabel>
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group controlId="grupoMilitancia">
                                                    <FloatingLabel
                                                        controlId="grupoMilitancia"
                                                        label="Grupo de militancia"
                                                        className="mb-3"
                                                    >
                                                        <Form.Control
                                                            type="text"
                                                            onChange={(e) => { this.onChange(e) }}
                                                            placeholder="Buscar Entrevista" />
                                                    </FloatingLabel>
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group controlId="entidad">
                                                    <FloatingLabel
                                                        controlId="entidad"
                                                        label="Entidad"
                                                        className="mb-3"
                                                    >
                                                        <Form.Control
                                                            type="text"
                                                            onChange={(e) => { this.onChange(e) }}
                                                            placeholder="Buscar Entrevista" />
                                                    </FloatingLabel>
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group controlId="transWhisper">
                                                    <Form.Select onChange={(e) => { this.onChange(e) }}>
                                                        <option value={0}>Con/Sin Transcripción Whisper</option>
                                                        <option value={1}>Con Transcripción Whisper</option>
                                                        <option value={2}>Sin Transcripción Whisper</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                            <Col md={4}>
                                                <Form.Group controlId="transWhisper2">
                                                    <Form.Select onChange={(e) => { this.onChange(e) }}>
                                                        <option value={0}>Con/Sin Transcripción Whisper 2.0</option>
                                                        <option value={1}>Con Transcripción Whisper 2.0</option>
                                                        <option value={2}>Sin Transcripción Whisper 2.0</option>
                                                    </Form.Select>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </Row>
                    </Form>
                    <Row className="py-6">Número de resultados: {this.state.data.length}</Row>
                    {this.currentUser.currentUser.role !== 3 &&
                        <Row>
                            <Col className="py-6">
                                { /*
                                <CSVLink data={this.state.dataExcel} filename={"Entrevistas.xlsx"}>
                                    <Button className="btn btn-success">Descargar lista</Button>
                                </CSVLink>
                    */ }
                                <Button className="btn btn-success pm-6" onClick={() => { this.exportCSV(this.state.dataExcel, "Testimonios") }}>Descargar Lista</Button>
                                <Link to={'/Testimonial/Entrevista'} className="ps-6"><Button>Nueva Entrevista</Button></Link>
                            </Col>
                        </Row>
                    }
                    {
                        this.state.data.map(post =>
                            <Col md="12" className="my-2" key={post.clasificacion}>
                                <Card>
                                    <Card.Body>
                                        <Card.Title><Link to={`/Testimonial/Detalles/${post._id}`}>{post.clasificacion} - {post.persona[0].nombre} ({post.tipoTestimoniante}) - {post.emi}</Link></Card.Title>
                                        <div className="separator my-5"></div>
                                        <Card.Text>
                                            <Row>
                                                <Col><strong>Lugar y Fecha:</strong> {post.entidad}, {moment(post.fecha).format('YYYY-MM-DD')}</Col>
                                                <Col><strong>Entrevistador(E)/Asistente(A):</strong> {post.entrevistador}</Col>
                                                <Col><strong>Transcriptor:</strong> {post.transcriptor}</Col>
                                                <Col><strong>Tipo de Entrevista:</strong> {post.tipoEntrevista}</Col>
                                            </Row>
                                            <Row>
                                                <Col><strong>Duración:</strong> {post.duracion}</Col>
                                                <Col><strong>Sesiones:</strong> {post.sesiones}</Col>
                                                <Col><strong>Material Adicional:</strong> {post.materialAdicional}</Col>
                                                <Col><strong>Tipo de Material Adicional:</strong> {post.tipoMaterialAdicional}</Col>
                                            </Row>
                                            <div className="separator my-5"></div>
                                            <Row>
                                                <Col>
                                                    <Row><strong>Graves Violaciones:</strong></Row>
                                                    <Row>
                                                        <span className='fw-semibold d-block fs-7'>
                                                            <ul>
                                                                {
                                                                    post.gravesViolaciones.map(gViolaciones =>
                                                                        <li key={gViolaciones._id}>{gViolaciones.nombre}</li>
                                                                    )
                                                                }
                                                            </ul>
                                                        </span>
                                                    </Row>
                                                </Col>
                                                <Col>
                                                    <Row><strong>Subcontextos:</strong></Row>
                                                    <Row>
                                                        <span className='fw-semibold d-block fs-7'>
                                                            <ul>
                                                                {
                                                                    post.subcontextos.map(gViolaciones =>
                                                                        <li key={gViolaciones._id}>{gViolaciones.nombre}</li>
                                                                    )
                                                                }
                                                            </ul>
                                                        </span>
                                                    </Row>
                                                </Col>
                                            </Row>
                                        </Card.Text>
                                    </Card.Body>
                                </Card>
                            </Col>
                        )
                    }
                </Container >
                {/* begin::Table container 
                < div className='' >
                    {/* begin::Table *}
                    < table className='table table-hover table-row-dashed table-row-gray-300 align-middle gs-0 gy-4' >
                        {/* begin::Table head *}
                        < thead >
                            <tr className='fw-bold text-muted'>
                                <th>Clasificación</th>
                                <th>
                                    <span className="d-block">Entidad</span>
                                    <span className="d-block">Lugar y Fecha</span>
                                </th>
                                <th className="min-w-150px">
                                    <span className="d-block">Nombre</span>
                                    <span className="d-block">Tipo Testimoniante</span>
                                </th>
                                <th>Grupo de Militancia</th>
                                <th>Pertenecía a Colectivo</th>
                                <th>EMI responsable</th>
                                <th>Entrevistador(E) / Asistente(A)</th>
                                <th>Transcriptor</th>
                                <th>
                                    <span className="d-block">Tipo de entrevista y Duración</span>
                                </th>
                                <th className="min-w-150px">Graves violaciones</th>
                                <th className="min-w-200px">Subcontextos</th>
                                <th>Sesiones</th>
                                <th>Material adicional</th>
                                <th>Tipo de material adicional</th>
                                <th>Detalles</th>
                            </tr>
                        </thead >
                        {/* end::Table head *}
                        {/* begin::Table body *}
                        <tbody>
                            {
                                this.state.data.map(post =>
                                    <tr key={post._id}>
                                        <td><span className='text-muted fw-semibold text-muted d-block fs-7'>
                                            <Link to={`/Testimonial/Detalles/${post._id}`}>{post.clasificacion}</Link></span></td>
                                        <td>
                                            <span className='text-dark fw-bold text-hover-primary fs-6'>{post.entidad}</span>
                                            <span className='text-muted fw-semibold text-muted d-block fs-7'>{post.lugar}</span>
                                            <span className='text-muted fw-semibold text-muted d-block fs-7'>{moment(post.fecha).format('YYYY-MM-DD')}</span>
                                        </td>
                                        <td>
                                            <span className='text-dark fw-bold text-hover-primary fs-6'>
                                                {post.persona[0].nombre}
                                            </span>
                                            <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                                {post.tipoTestimoniante}
                                            </span>
                                        </td>
                                        <td><span className='text-muted fw-semibold text-muted d-block fs-7'>{post.grupoMilitancia}</span></td>
                                        <td><span className='text-muted fw-semibold text-muted d-block fs-7'>{post.colectivo}</span></td>
                                        <td><span className='text-muted fw-semibold text-muted d-block fs-7'>{post.emi}</span></td>
                                        <td><span className='text-muted fw-semibold text-muted d-block fs-7'>{post.entrevistador}</span></td>
                                        <td><span className='text-muted fw-semibold text-muted d-block fs-7'>{post.transcriptor}</span></td>
                                        <td>
                                            <span className='text-dark fw-bold text-hover-primary fs-6'>{post.tipoEntrevista}</span>
                                            <span className='text-muted fw-semibold text-muted d-block fs-7'>{post.duracion}</span>
                                        </td>
                                        <td>
                                            <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                                <ul>
                                                    {
                                                        post.gravesViolaciones.map(gViolaciones =>
                                                            <li key={gViolaciones._id}>{gViolaciones.nombre}</li>
                                                        )
                                                    }
                                                </ul>
                                            </span>
                                        </td>
                                        <td>
                                            <span className='text-muted fw-semibold text-muted d-block fs-7'>
                                                <ul>
                                                    {
                                                        post.subcontextos.map(gViolaciones =>
                                                            <li key={gViolaciones._id}>{gViolaciones.nombre}</li>
                                                        )
                                                    }
                                                </ul>
                                            </span>
                                        </td>
                                        <td><span className='text-muted fw-semibold text-muted d-block fs-7'>{post.sesiones}</span></td>
                                        <td><span className='text-muted fw-semibold text-muted d-block fs-7'>{post.materialAdicional}</span></td>
                                        <td><span className='text-muted fw-semibold text-muted d-block fs-7'>{post.tipoMaterialAdicional}</span></td>
                                        <td>
                                            <div className='d-flex flex-shrink-0'>
                                                <Link to={`/Testimonial/Detalles/${post._id}`}
                                                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                                                >
                                                    <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
                                                </Link >
                                            </div>
                                        </td>
                                    </tr>
                                )
                            }
                        </tbody>
                        {/* end::Table body *}
                    </table >
                    {/* end::Table *}
                </div >

                {/*  <Container fluid>
                    <Row>
                        <Col>
                            <Form>
                                <Form.Group controlId="formSearch">
                                    <FloatingLabel
                                        controlId="buscar"
                                        label="Buscar Entrevista"
                                        className="mb-3"
                                    >
                                        <Form.Control type="text" placeholder="Buscar Entrevista" />
                                    </FloatingLabel>
                                </Form.Group>
                            </Form>
                        </Col>
                        <Col>
                            <Link to={'/Testimonial/Entrevista'}><Button>Nueva Entrevista</Button></Link>
                        </Col>
                    </Row>
                    <Row>
                        <Table>
                            <thead>
                                <tr className="bold">
                                    <th>Clasificación</th>
                                    <th>Fecha</th>
                                    <th>Entidad</th>
                                    <th>Lugar</th>
                                    <th>Nombre</th>
                                    <th>EMI responsable</th>
                                    <th>Tipo de entrevista</th>
                                    <th>Tipo de Testimoniante</th>
                                    <th>Graves violaciones</th>
                                    <th>Subcontextos</th>
                                    <th>Sesiones de entrevista</th>
                                    <th>Acciones</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    this.state.data.map(post =>
                                        <tr key={post._id}>
                                            <td>{post.clasificacion}</td>
                                            <td>{moment(post.fecha).format('YYYY-MM-DD')}</td>
                                            <td>{post.entidad}</td>
                                            <td>{post.lugar}</td>
                                            <td>{post.persona[0].nombre}</td>
                                            <td>{post.emi}</td>
                                            <td>{post.tipoEntrevista}</td>
                                            <td>{post.tipoTestimoniante}</td>
                                            <td>
                                                <ul>
                                                    {
                                                        post.gravesViolaciones.map(gViolaciones =>
                                                            <li>{gViolaciones.nombre}</li>
                                                        )
                                                    }
                                                </ul>
                                            </td>
                                            <td>
                                                <ul>
                                                    {
                                                        post.subcontextos.map(gViolaciones =>
                                                            <li>{gViolaciones.nombre}</li>
                                                        )
                                                    }
                                                </ul>
                                            </td>
                                            <td>{post.tipo}</td>
                                            <td>
                                                <Button>Editar</Button>
                                                {' '}
                                                <Link to={`/Persona/detalles/${post._id}`}><Button>Detalles</Button></Link>{' '}
                                                <Button>Eliminar</Button></td>
                                        </tr>
                                    )
                                }
                            </tbody>
                        </Table>
                    </Row>
                </Container> */}
            </>
        );
    }

}

export default EntrevistaIndividualIndex;